export const size = {
    tablet: '767px',
    laptop: '1191px',
}
export const device = {
    mobile: `(max-width: ${size.tablet})`,
    tablet: `(max-width: ${size.laptop})`,
};

export const OPTION_CHANTS = 'chants';

export const OPTION_NO = 'no_option';

export const TYPE_DECOUPE = 'decoupe';
export const TYPE_PLIAGE = 'pliage';

export const SIZE_DIM_NAME = ["A", "B", "C", "D", "E", "P"];
export const DECOUPE_DIM_NAME = ["x", "y", "z", "dA", "dB", "1", "2", "3", "4"];

export const MV_D_ALLOW = [6, 8, 10, 11, 12, 14, 16, 20, 26, 30, 40, 45, 50, 60, 65, 70, 75];

export const MAX_A = 3000;
export const MIN_A = 40;
export const MAX_B = 1500;
export const MIN_B = 40;

export const MIN_DEGREE = 30;

export const MIN_COUPE = 0;

export const PHONE_NUMBER = '';

export const PRIX_PAR_PLIAGE = 10;

export const PRIX_PAR_PERCAGE_SIMPLE_MV = 18;

export const PRIX_PAR_PERCAGE_DOUBLE_TRIPLE_MV = 110;

export const PRIX_SUPP_USINAGE_ET_PLACAGE_FORM = 126; // pour les formes des bois sauf rectangle